<template>
  <el-container class="content" style="display: block;">

    <div :style="{'width':otherWidth+'px','height':leftheight+'px'}"
         style="display: flex;flex-wrap: wrap;background-color: #000;overflow-y: scroll;" @scroll="handleScroll">


      <div v-for="(video, index) in list" :key="index" v-if="yulan == 1 && index <vi_length">
        <div class="donghuap" :style="{'width':vwidth+'px','height':vwidth+'px'}">
          <div v-if="video['types'] == 1" style="display: flex;flex-wrap: wrap;">
            <div @click="videoChange(video['id'],video['url'])" :style="videoChangeCheck(video['id'],video['bkg'])" style="overflow: hidden;">

              <video v-if="video['v_url'] != '无'" autoplay loop muted playsinline style="object-fit: contain;" :style="{'width': vwidth+'px','height': vwidth+'px'}">
                <source :src="video['v_url']" type="video/mp4" />
              </video>
              <img v-else v-lazy="video['img']" :width="vwidth" :height="vwidth" style="object-fit: contain;">
            </div>
            <div :class="{ddonghua:(video['typed'] == 1),edonghua:(video['typeb'] == 1),adonghua:(video['typea'] == 2)}"
                 class="donghuai" @click="videoChange(video['id'],video['url'])"
                 :style="{'width':vwidth+'px','height':vwidth+'px','margin-left':'-'+vwidth+'px'}"
                 style="color: #ffffff;text-align: center;">
              <div :style="{'margin-top':vwidth*0.75+'px','height':vwidth*0.25+'px','line-height':vwidth*0.25+'px'}"
                   style="background-color: #000;white-space: nowrap;overflow: hidden;">{{ video['ci'] }}
              </div>
            </div>
          </div>
          <div v-if="video['types'] == 2" :style="videoChangeCheck(video['id'],video['bkg'])">
            <div @click="videoChange(video['id'],video['url'])" :style="{'width':vwidth+'px','height':vwidth+'px'}"
                 style="color: #ffffff;text-align: left;">
              <div style="overflow: hidden;">{{ video['beizhu'] }}</div>
            </div>
          </div>
          <div v-if="video['types'] == 3">
            <div @click="videoChange(video['id'],video['url'])" :style="videoChangeCheck(video['id'],video['bkg'])"
                 style="width: 100%;height: 100%;">
              <img v-lazy="video['img']" :width="vwidth*0.8" :height="vwidth*0.8" style="object-fit: contain;padding: ;"
                   :style="{'padding':vwidth*0.1+'px'}">
            </div>
          </div>
        </div>
      </div>

      <div v-for="(video, index) in videoData" :key="index" v-if="yulan == 2">
        <div class="donghuap" :style="{'width':vwidth+'px','height':vwidth+'px'}">
          <div v-if="video['types'] == 1" style="display: flex;flex-wrap: wrap;">
            <div @click="open(video['url'])" :style="{'background-image':`url(${video['bkg']})`}" style="overflow: hidden;">
              <video v-if="video['v_url'] != '无'" autoplay loop muted playsinline style="object-fit: contain;" :style="{'width': vwidth+'px','height': vwidth+'px'}">
                <source :src="video['v_url']" type="video/mp4" />
              </video>
              <img v-else :src="video['img']" :width="vwidth" :height="vwidth" style="object-fit: contain;">
            </div>
            <div :class="{ddonghua:(video['typed'] == 1),edonghua:(video['typeb'] == 1),adonghua:(video['typea'] == 2)}"
                 class="donghuai" @click="open(video['url'])"
                 :style="{'width':vwidth+'px','height':vwidth+'px','margin-left':'-'+vwidth+'px'}"
                 style="color: #ffffff;text-align: center;">
              <div :style="{'margin-top':vwidth*0.75+'px','height':vwidth*0.25+'px','line-height':vwidth*0.25+'px'}"
                   style="background-color: #000;white-space: nowrap;overflow: hidden;">{{ video['ci'] }}
              </div>
            </div>
          </div>
          <div v-if="video['types'] == 2" :style="{'background-image':`url(${video['bkg']})`}">
            <div :style="{'width':vwidth+'px','height':vwidth+'px'}" style="color: #ffffff;text-align: left;">
              <div style="overflow: hidden;">{{ video['beizhu'] }}</div>
            </div>
          </div>
          <div v-if="video['types'] == 3">
            <div @click="open(video['url'])" :style="{'background-image':`url(${video['bkg']})`}"
                 style="width: 100%;height: 100%;">
              <img :src="video['img']" :width="vwidth*0.8" :height="vwidth*0.8" style="object-fit: contain;padding: ;"
                   :style="{'padding':vwidth*0.1+'px'}">
            </div>
          </div>
        </div>
      </div>


    </div>
    <div style="position: absolute;top: 0;z-index: 1005;background-color: #000;z-index: 1005;"
         :style="{'width':screenHeight+'px','height':screenHeight+'px','left':otherWidth+'px'}">
      <video width="100%" height="100%" ref="videoPlayer" @ended="restartVideo" controls
             controlslist="nodownload noplaybackrate" disablePictureInPicture="true" id="myVideo" v-if="ishow">
        <source :src="video_url" type="video/mp4">

      </video>

      <!-- <div style="position: absolute;z-index: 1010;bottom: 2px;" :style="{'right':0+'px'}">

        <div style="background-color: #000;color: #fff;padding-left: 5px;padding-right: 5px;border: 1px solid #fff;"
             @click="down()"><a style="color: #fff;">能力文档</a></div>
        <div style="background-color: #000;color: #fff;padding-left: 5px;padding-right: 5px;border: 1px solid #fff;"><a
          :href="downUrl2" style="color: #fff;">报价清单</a></div>
        <div style="background-color: #000;color: #fff;padding-left: 5px;padding-right: 5px;border: 1px solid #fff;"><a
          :href="downUrl3" style="color: #fff;">生产合同</a></div>
      </div> -->
      <div class="grid_b">
        <div class="cell_b">
            <img :src="require('@/assets/image/hetong.png')" alt="Icon 1" class="icon_b">
            <p class="text_b">合同</p>
        </div>
        <div class="cell_b">
            <img :src="require('@/assets/image/nenglibiao.png')" alt="Icon 2" class="icon_b">
            <p class="text_b">能力表</p>
        </div>
        <div class="cell_b">
            <img :src="require('@/assets/image/baojiadan.png')" alt="Icon 3" class="icon_b">
            <p class="text_b">报价单</p>
        </div>
        <div class="cell_b" @click="zongjiashow=true">
            <img :src="zongjiapayImge" alt="Icon 4" class="icon_b" v-if="zongjiaPayImgStatus == 0" >
            <img :src="zongjiaPayImg" alt="Icon 4" class="icon_b" v-if="zongjiaPayImgStatus == 1">
            <p class="text_b">付款码</p>
        </div>
        <img :src="zongjiapayImge" @click="getOnece1()" v-if="zongjiashow && zongjiaPayImgStatus == 0" style="width: 100%;height: 100%;z-index: 99999;position: absolute;top:0;left:0;"/>
        <img :src="zongjiaPayImg"  @click="zongjiashow=false" v-if="zongjiashow && zongjiaPayImgStatus == 1"  style="width: 100%;height: 100%;z-index: 99999;position: absolute;top:0;left:0;" />
      </div>
      <div>
        <el-row style="position: absolute;left: 5px;top: 5px;" v-if="left_show == 1">
          <img src="https://images.yoooooo.com/crm/reseller/tubiaog.gif" @click="leftShow(2)" width="30px" height="30px"
               style="object-fit: contain;">
        </el-row>
        <el-row style="position: absolute;left: 5px;top: 5px;display: flex;flex-direction:row;" v-if="left_show == 2">
          <img src="https://images.yoooooo.com/crm/reseller/tubiaok.png" @click="leftShow(1)" width="30px" height="30px"
               style="object-fit: contain;">
          <!-- <div class="s_q_sc_left" @click="searchLeft()" style="height: ;">搜索</div> -->
          <img src="https://images.yoooooo.com/crm/reseller/sousuo2.png" @click="searchLeft()"
               v-if="other_left_sousuo !=1" width="80px" height="30px" style="object-fit: contain;margin-left: 12px;">
          <img src="https://images.yoooooo.com/crm/reseller/sousuo1.png" @click="searchLeft()"
               v-if="other_left_sousuo ==1" width="80px" height="30px" style="object-fit: contain;margin-left: 12px;">
          <img src="https://images.yoooooo.com/crm/reseller/qita2.png" @click="otherLeft()" v-if="other_left !=1"
               width="80px" height="30px" style="object-fit: contain;margin-left: 12px;">
          <img src="https://images.yoooooo.com/crm/reseller/qita1.png" @click="otherLeft()" v-if="other_left ==1"
               width="80px" height="30px" style="object-fit: contain;margin-left: 12px;">
          <img src="https://images.yoooooo.com/crm/reseller/shangchuan2.png" @click="scLeft()" v-if="sc_left !=1"
               width="80px" height="30px" style="object-fit: contain;margin-left: 12px;">
          <img src="https://images.yoooooo.com/crm/reseller/shangchuan1.png" @click="scLeft()" v-if="sc_left ==1"
               width="80px" height="30px" style="object-fit: contain;margin-left: 12px;">


          <!-- <img src="https://images.yoooooo.com/crm/reseller/shangchuan1.png" @click="searchLeft()"  width="80px" height="30px" style="object-fit: contain;margin-left: 12px;"> -->
          <!-- <div class="s_q_sc_left" @click="otherLeft()">其他</div>
          <div class="s_q_sc_left">上传</div> -->
          <div class="sc_left" v-if="sc_left == 1" style="position: absolute;top: 40px;left: 168px;"
               :style="{'width':screenHeight*0.5+'px','height':screenHeight*0.3+'px'}">
            <!-- <div style="position: relative;">
              <img src="https://images.yoooooo.com/crm/reseller/sck.png"  width="100%" height="100%" style="object-fit: contain;">
              <img src="https://images.yoooooo.com/crm/reseller/bdsc1.png" @click="uploadb()"  width="38.5%"  style="object-fit: contain;position: absolute;bottom: 7%;right: 5%;">
              <img src="https://images.yoooooo.com/crm/reseller/pssc1.png" @click="uploadsx()"  width="38.5%"  style="object-fit: contain;position: absolute;bottom: 7%;left: 5%;">
            </div> -->
            <img src="https://images.yoooooo.com/crm/reseller/shangchuan.png" width="100%" height="100%"
                 style="object-fit: contain;">
            <img src="https://images.yoooooo.com/crm/reseller/shangchuanp.png" @click="uploadsx()" v-if="paishe == 0"
                 width="38.5%" style="object-fit: contain;position: absolute;bottom: 7px;left: 10.5%;">
            <img src="https://images.yoooooo.com/crm/reseller/shangchuanpc.png" @click="uploadsx()" v-if="paishe == 1"
                 width="19%" style="object-fit: contain;position: absolute;bottom: 7px;left: 10.5%;">
            <img src="https://images.yoooooo.com/crm/reseller/shangchuanps.png" @click="uploadPaishe()"
                 v-if="paishe == 1" width="19%" style="object-fit: contain;position: absolute;bottom: 7px;left: 31%;">
            <img src="https://images.yoooooo.com/crm/reseller/shangchuanb.png" @click="uploadb()" width="38.5%"
                 style="object-fit: contain;position: absolute;bottom: 7px;right: 10.5%;">
            <img v-if="photo" :src="photo" alt="Photo" style="position: absolute;z-index: 10;left:12%;top:15%;"
                 :style="{'width':screenHeight*0.38+'px','height':screenHeight*0.22+'px'}"/>
            <el-upload
              class="upload-demo"
              drag
              style="display: none;"

              action="https://data3.yoooooo.com/index.php/index/data/pythonImgSave"
              :on-success="handleAvatarSuccess"
              multiple>
              <i class="el-icon-upload"></i>
              <div ref="uploadImg" class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>

            </el-upload>
            <canvas ref="canvas" style="display: none;"></canvas>

          </div>
          <div class="other_left" v-if="other_left == 1">
            <textarea id="other_left_textarea" v-model="beizhu" style="font-size: 14px;font-weight: bold;"></textarea>
            <img src="https://images.yoooooo.com/crm/reseller/other_qr.png" @click="otherLeftAdd()" width="120px"
                 height="70px" style="position:absolute;bottom: -22px;object-fit: contain;">
          </div>
          <div class="other_left_sousuo" v-if="other_left_sousuo == 1">

            <input id="other_left_input" v-model="search_left" placeholder="请输入..."
                   style="font-size: 14px;font-weight: bold;margin-bottom: 10px;"/>
            <img src="https://images.yoooooo.com/crm/reseller/sousuoqd.png" @click="otherLeftQd()" width="100px"
                 height="30px" style="position:absolute;bottom: -18px;object-fit: contain;right: 112px;">
            <img src="https://images.yoooooo.com/crm/reseller/sousuoqx.png" @click="otherLeftQx()" width="100px"
                 height="30px" style="position:absolute;bottom: -18px;object-fit: contain;right: 32px;">
          </div>
        </el-row>
        <el-row style="position: absolute;right: 5px;top: 5px;" v-if="right_show == 1">
          <img src="https://images.yoooooo.com/crm/reseller/tubiaog.gif" @click="rightShow(2)" width="30px"
               height="30px" style="object-fit: contain;">
        </el-row>
        <el-row style="position: absolute;right: 5px;top: 5px;display: flex;flex-direction:row;" v-if="right_show == 2">
          <!-- <div class="s_q_sc_right" @click="searchRight()" style="height: ;">搜索</div>
          <div class="s_q_sc_right" @click="otherRight()" >其他</div> -->
          <img src="https://images.yoooooo.com/crm/reseller/sousuo2.png" @click="searchRight()"
               v-if="other_right_sousuo !=1" width="80px" height="30px" style="object-fit: contain;margin-right: 12px;">
          <img src="https://images.yoooooo.com/crm/reseller/sousuo1.png" @click="searchRight()"
               v-if="other_right_sousuo ==1" width="80px" height="30px" style="object-fit: contain;margin-right: 12px;">
          <img src="https://images.yoooooo.com/crm/reseller/qita2.png" @click="otherRight()" v-if="other_right !=1"
               width="80px" height="30px" style="object-fit: contain;margin-right: 12px;">
          <img src="https://images.yoooooo.com/crm/reseller/qita1.png" @click="otherRight()" v-if="other_right ==1"
               width="80px" height="30px" style="object-fit: contain;margin-right: 12px;">
          <img src="https://images.yoooooo.com/crm/reseller/tubiaok.png" @click="rightShow(1)" width="30px"
               height="30px" style="object-fit: contain;">
          <div class="other_right" v-if="other_right == 1">
            <textarea id="other_right_textarea" v-model="beizhu_right"
                      style="font-size: 14px;font-weight: bold;"></textarea>
            <img src="https://images.yoooooo.com/crm/reseller/other_qr.png" @click="otherRightAdd()" width="120px"
                 height="70px" style="position:absolute;bottom: -22px;object-fit: contain;">
          </div>
          <div class="other_right_sousuo" v-if="other_right_sousuo == 1">

            <input id="other_right_input" v-model="search_right" placeholder="请输入..."
                   style="font-size: 14px;font-weight: bold;"/>
            <img src="https://images.yoooooo.com/crm/reseller/sousuoqd.png" @click="otherRightQd()" width="100px"
                 height="30px" style="position:absolute;bottom: -18px;object-fit: contain;right: 112px;">
            <img src="https://images.yoooooo.com/crm/reseller/sousuoqx.png" @click="otherRightQx()" width="100px"
                 height="30px" style="position:absolute;bottom: -18px;object-fit: contain;right: 32px;">
          </div>
        </el-row>
      </div>
      <div>
        <el-row style="position: absolute;left: 48%;bottom: 10px;" v-if="yulan == 1"
                :style="{'left':(screenHeight-80)/2+'px'}">
          <!-- <div class="yl_fh" @click="letSee()" >预览</div> -->
          <img src="https://images.yoooooo.com/crm/reseller/queren.png" @click="letSee()" width="120px" height="40px"
               style="object-fit: contain;">
        </el-row>
        <el-row style="position: absolute;display: flex;flex-direction:row;" v-if="yulan == 2"
                :style="{'left':screenWidth*0.4+'px','bottom':screenHeight*0.45+'px'}">
          <img src="https://images.yoooooo.com/crm/reseller/tanchu.png" :width="screenWidth*0.2+'px'"
               :height="screenHeight*0.2+'px'"
               style="position:absolute;bottom: -18px;object-fit: contain;right: 112px;">
          <img src="https://images.yoooooo.com/crm/reseller/tanchuqr.png" @click="zuhe()" :width="screenWidth*0.05+'px'"
               :height="screenHeight*0.05+'px'" style="position:absolute;bottom: 0px;object-fit: contain;right: 312px;"
               :style="{'right':screenWidth*0.4*0.4+'px'}">
          <img src="https://images.yoooooo.com/crm/reseller/tanchuqx.png" @click="letBack()"
               :width="screenWidth*0.05+'px'" :height="screenHeight*0.05+'px'"
               style="position:absolute;bottom: 0px;object-fit: contain;right: 112px;"
               :style="{'right':screenWidth*0.4*0.2+'px'}">
          <!-- <div class="yl_fh" @click="letBack()" >返回选择</div>
          <div class="yl_fh" @click="zuhe()" style="margin-left: 20px;">确认组合</div> -->
        </el-row>
      </div>
      <div class="float-animation"
           style="z-index: 1006;color: #ffffff;position: absolute;top: 10%;border: 1px solid #fff;" v-if="dinggou2 == 2"
           @click="dg(1)">
        <img :src="dinggou" :width="120" :height="100" style="object-fit: contain;">
        <div style="text-align: center;">全球订购</div>

      </div>
      <div class="float-animation1"
           style="z-index: 1006;color: #ffffff;position: absolute;top: 10%;border: 1px solid #fff;" v-if="daili2 == 2"
           @click="dl(1)">
        <img :src="daili" :width="120" :height="100" style="object-fit: contain;">
        <div style="text-align: center;">全球代理</div>

      </div>
      <div
        style="z-index: 1006;color: #ffffff;position: absolute;bottom: 0;right:0%;border: 1px solid #fff;width: 40%;height: 40%;background-color: #000;"
        v-if="daili2 == 1">
        <div style="color: #fff;text-align: center;margin-top: 2%;">全球代理</div>
        <el-row :span="2" style="margin-top: 10%;margin-left: 5%;">
          <el-col :span="4" style="margin-top: 7px;">
            称呼:
          </el-col>
          <el-col :span="16">
            <el-input v-model="qiye" style="width: 200px;" placeholder="请输入您的姓名/公司名"></el-input>
          </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 10px;margin-left: 5%;">
          <el-col :span="4" style="margin-top: 7px;">
            电话:
          </el-col>
          <el-col :span="16">
            <el-input v-model="email" style="width: 200px;" placeholder="请输入您的手机号"></el-input>
          </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 10px;margin-left: 5%;">
          <el-col :span="4" style="margin-top: 7px;">
            其他:
          </el-col>
          <el-col :span="16">
            <el-input v-model="other" style="width: 200px;" placeholder="请输入您的其他联系方式"></el-input>
          </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 20px;margin-left: 30%;">
          <el-button type="primary" style="background-color: #409eff;" @click="commitdl()" round>提交</el-button>
        </el-row>
        <div style="z-index: 1006;color: #ffffff;" v-if="daili" @click="dg()">
          <img :src="daili" width="80%" height="80%"
               style="object-fit: contain;position: absolute;bottom: 0;right: -20%;">


        </div>
        <div style="position: absolute;right:2px;top:2px;" @click="dl(2)"><i class="el-icon-circle-close"
                                                                             style="font-size: 25px;color: #ffffff;"></i>
        </div>
      </div>
      <div
        style="z-index: 1006;color: #ffffff;position: absolute;bottom: 0;border: 1px solid #fff;width: 40%;height: 40%;background-color: #000;"
        v-if="dinggou2 == 1">
        <div style="color: #fff;text-align: center;margin-top: 2%;">全球订购</div>
        <el-row :span="2" style="margin-top: 10%;margin-left: 5%;">
          <el-col :span="4" style="margin-top: 7px;">
            称呼:
          </el-col>
          <el-col :span="16">
            <el-input v-model="qiye1" style="width: 200px;" placeholder="请输入您的姓名/公司名"></el-input>
          </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 10px;margin-left: 5%;">
          <el-col :span="4" style="margin-top: 7px;">
            电话:
          </el-col>
          <el-col :span="16">
            <el-input v-model="email1" style="width: 200px;" placeholder="请输入您的手机号"></el-input>
          </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 10px;margin-left: 5%;">
          <el-col :span="4" style="margin-top: 7px;">
            其他:
          </el-col>
          <el-col :span="16">
            <el-input v-model="other1" style="width: 200px;" placeholder="请输入您的其他联系方式"></el-input>
          </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 20px;margin-left: 30%;">
          <el-button type="primary" style="background-color: #409eff;" @click="commitdg()" round>提交</el-button>
        </el-row>
        <div style="z-index: 1006;color: #ffffff;" v-if="dinggou" @click="dg()">
          <img :src="dinggou" width="80%" height="80%"
               style="object-fit: contain;position: absolute;bottom: 0;right: -20%;">


        </div>
        <div style="position: absolute;right:2px;top:2px;" @click="dg(2)"><i class="el-icon-circle-close"
                                                                             style="font-size: 25px;color: #ffffff;"></i>
        </div>
      </div>
    </div>

    <div style="position: absolute;top: 0;z-index: 1005;background-color: #000;z-index: 1005;overflow-y: scroll;"
         :style="{'width':otherWidth+'px','height':screenHeight+'px','right':0}">
      <ul style="color: #fff;width: 100%;overflow-y: scroll;display: flex;flex-direction: column;" v-if="yulan == 1">

        <li v-for="(item, index) in texts" :key="index" @click="textChange(item['id'],item['url'],item['t'])"
            :style="textChangeCheck(item['id'],item['color'])"
            style="box-shadow: inset 0px 0px 2px rgba(0, 0, 0, 0.5);padding: 1px;border: 0.1pt solid #616161">
          {{ item['name'] }}
        </li>


      </ul>

      <ul style="color: #fff;width: 100%;overflow-y: scroll;display: flex;flex-direction: column;" v-if="yulan == 2">

        <li v-for="(item, index) in textData" :key="index" @click="textChange(item['id'],item['url'],item['t'])"
            :style="textChangeCheck(item['id'],item['color'])"
            style="box-shadow: inset 0px 0px 2px rgba(0, 0, 0, 0.5);padding: 1px;border: 0.1pt solid #616161">
          {{ item['name'] }}
        </li>


      </ul>

    </div>
    <!-- <div class="zhifu_overlay" v-if="zhifuShow == 0"></div>
    <div class="zhifu" style="z-index: 1020;" v-if="zhifuShow == 0">
      <div style="display: flex;position: absolute;top:20%;left:2.5vw;">
        <div :class="(month == 1)?'zhifu_mc':'zhifu_m'" @click="changePrice(1)">
          <div class="zhifu_mt">1个月</div>
          <div class="zhifu_jg"><span style="font-size: 14px;">￥</span>{{ price1 }}</div>
        </div>
        <div :class="(month == 3)?'zhifu_mc':'zhifu_m'" @click="changePrice(3)">
          <div class="zhifu_mt">3个月</div>
          <div class="zhifu_jg"><span style="font-size: 14px;">￥</span>{{ price3 }}</div>
        </div>
        <div :class="(month == 6)?'zhifu_mc':'zhifu_m'" @click="changePrice(6)">
          <div class="zhifu_mt">6个月</div>
          <div class="zhifu_jg"><span style="font-size: 14px;">￥</span>{{ price6 }}</div>
        </div>
        <div :class="(month == 12)?'zhifu_mc':'zhifu_m'" @click="changePrice(12)">
          <div class="zhifu_mt">12个月</div>
          <div class="zhifu_jg"><span style="font-size: 14px;">￥</span>{{ price12 }}</div>
        </div>
      </div>
      <div class="zhifu_jiage">
        应付金额:
        <span style="color: #ff6000;letter-spacing: 6px;">
          <span style="font-size: 18px;font-weight: 100;">￥</span>{{ price }}
        </span>
        <span style="font-size:18px">(<span style="color: #ff6000;">{{ month }}</span>个月)</span>
      </div>
      <div class="zhifu_ewm">
        <img src="https://images.yoooooo.com/crm/reseller/zhifuewm.png"/>
      </div>
    </div> -->


    <div class="beian1">
      <a href="https://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank"
         style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


    </div>
    <el-dialog
      title="是否确认组合新链接"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>确认组合？</span>
      <span slot="footer" class="dialog-footer">
   	<el-button @click="letBack()">返回选择</el-button>
   	<el-button type="primary" @click="zuhe()">确 定</el-button>
     </span>
    </el-dialog>
    <div class="zhifu_overlay" v-if="zhifuShow == 0"></div>
    <!-- <div class="reseller" v-if="zhifuShow == 0">
      <div class="reseller-header">会员订购</div>
      <div class="reseller-content">
        <div class="reseller-content-box" :class="{'active':month == 1}" @click="changePrice(1)">
          <p>1个月</p>
          <p>￥<span class="fontColor1">{{ price1 }}</span></p>
        </div>
        <div  class="reseller-content-box" :class="{'active':month == 3}" @click="changePrice(3)">
          <p>3个月</p>
          <p>￥<span class="fontColor1">{{ price3 }}</span></p>
        </div>
        <div  class="reseller-content-box" :class="{'active':month == 6}" @click="changePrice(6)">
          <p>6个月</p>
          <p>￥<span class="fontColor1">{{ price6 }}</span></p>
        </div>
        <div  class="reseller-content-box" :class="{'active':month == 12}" @click="changePrice(12)">
          <p>12个月</p>
          <p>￥<span class="fontColor1">{{ price12 }}</span></p>
        </div>
      </div>
      <div class="reseller-text">应付金额：￥<span class="fontColor2">{{ price }}</span>（<span class="fontColor3">{{ month }}</span>个月）</div>
      <div class="reseller-wx" v-if="payImg">
        <img :src="payImg" style="width: 100%;" v-if="payImgStatus == 1"/>
        <img :src="payImge" @click="getOnece()" style="width: 100%;" v-if="payImgStatus == 0"/>
      </div>
      <div class="reseller-font">
        <p>使用微信/支付宝 扫码支付</p>
        <p>支付即视为你同意 <span class="fontColor4">相关协议</span> 条例</p>
      </div>
    </div> -->
    <div class="reseller" v-if="zhifuShow == 0">
      <div class="reseller-header" :style="{ fontSize: dynamicFontSize24 + 'px' }">会员订购</div>
      <div class="reseller-content">
        <div class="reseller-content-box" :style="{ fontSize: dynamicFontSize20 + 'px' }" :class="{'active':month == 1}" @click="changePrice(1)">
          <p>1个月</p>
          <p>￥<span class="fontColor1"  :style="{ fontSize: dynamicFontSize30 + 'px' }">{{ price1 }}</span></p>
        </div>
        <div  class="reseller-content-box":style="{ fontSize: dynamicFontSize20 + 'px' }" :class="{'active':month == 3}" @click="changePrice(3)">
          <p >3个月</p>
          <p>￥<span class="fontColor1"  :style="{ fontSize: dynamicFontSize30 + 'px' }">{{ price3 }}</span></p>
        </div>
        <div  class="reseller-content-box" :style="{ fontSize: dynamicFontSize20 + 'px' }" :class="{'active':month == 6}" @click="changePrice(6)">
          <p>6个月</p>
          <p>￥<span class="fontColor1"  :style="{ fontSize: dynamicFontSize30 + 'px' }">{{ price6 }}</span></p>
        </div>
        <div  class="reseller-content-box" :style="{ fontSize: dynamicFontSize20 + 'px' }" :class="{'active':month == 12}" @click="changePrice(12)">
          <p>12个月</p>
          <p>￥<span class="fontColor1"  :style="{ fontSize: dynamicFontSize30 + 'px' }">{{ price12 }}</span></p>
        </div>
      </div>
      <div class="reseller-text" :style="{ fontSize: dynamicFontSize16 + 'px' }">应付金额：<span style="color:#fae83e">￥</span><span class="fontColor2" :style="{ fontSize: dynamicFontSize26 + 'px' }">{{ price }}</span>（<span class="fontColor3" :style="{ fontSize: dynamicFontSize16 + 'px' }" >{{ month }}</span>个月）</div>
      <div class="pay-type">
        <div class="zfb">
          <p class="zfb-span">支付宝</p>
          <img v-if="payType == 2" :src="require('@/assets/image/radioc.png')" width="20" height="20" alt="" class="" style="margin-left: 40px;margin-top: 15px">
          <img v-if="payType == 1" @click="payTypeChange(2)" :src="require('@/assets/image/radio.png')" width="20" height="20" alt="" class="" style="margin-left: 40px;margin-top: 15px">
        </div>

        <div class="wx">
          <p class="wx-span">微信支付</p>
          <img v-if="payType == 1" :src="require('@/assets/image/radioc.png')" width="20" height="20" alt="" class="" style="margin-left: 20px;margin-top: 15px">
          <img v-if="payType == 2" @click="payTypeChange(1)" :src="require('@/assets/image/radio.png')" width="20" height="20" alt="" class="" style="margin-left: 20px;margin-top: 15px">
        </div>


      </div>

      <div class="reseller-wx" v-if="payImg">
        <img :src="payImg" style="width: 100%;" v-if="payImgStatus == 1 && payType == 1"/>
        <iframe :src="zhifubaoSrc" width="100%" height="100%" frameborder="0" v-if="zhifubaoSrc && payType == 2"></iframe>
        <img :src="payImge" @click="getOnece()" style="width: 100%;" v-if="payImgStatus == 0"/>
      </div>
      <div class="reseller-font">
        <p :style="{ fontSize: dynamicFontSize16 + 'px' }">使用微信/支付宝 扫码支付</p>
        <p :style="{ fontSize: dynamicFontSize16 + 'px' }">支付即视为你同意 <span class="fontColor4" :style="{ fontSize: dynamicFontSize20 + 'px' }">相关协议</span> 条例</p>
      </div>
    </div>
  </el-container>


</template>


<script>

export default {
  data() {
    return {
      qiye: '',
      email: '',
      other: '',
      qiye1: '',
      email1: '',
      other1: '',
      dlurl: '',
      dgurl: '',
      cshow: false,
      cshow1: false,
      cshow2: false,
      cshow3: false,
      vshow: false,
      list: [],
      shopkb: [],
      daili2: 3,
      dinggou2: 3,
      daili: '',
      dinggou: '',
      dailis: [],
      dinggous: [],
      texts: [],
      ishow: true,
      videos: [],
      video_url: '',
      id: this.$route.query.id.replace(/ /g, "+"),
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      otherWidth: (window.innerWidth - window.innerHeight) / 2,
      vwidth: ((window.innerWidth - window.innerHeight) / 2 - 12) / 6,
      vheight: window.innerHeight / 200,
      leftheight: 0,
      downUrl1: '',
      downUrl2: '',
      downUrl3: '',
      videos: [],
      textChose: [],
      videoData: [],
      textData: [],
      listSee: [],
      textsSee: [],
      dialogVisible: false,
      yulan: 1,
      left_show: 1,
      right_show: 1,
      other_left: 0,
      other_right: 0,
      other_left_sousuo: 0,
      other_right_sousuo: 0,
      beizhu: '',
      search_left: '',
      search_right: '',
      beizhu_right: '',
      sc_left: 0,
      photo: null,
      stream: null,
      formData: '',
      paishe: 0,
      month: 1,
      price: 299,
      price1: 299,
      price3: 897,
      price6: 1790,
      price12: 3300,
      zhifuShow: 1,
      token: localStorage.getItem('token'),
      company: '',
      logo: '',
      baseFontSize30:30,
      baseFontSize26:26,
      baseFontSize24:24,
      baseFontSize20:20,
      baseFontSize16:16,
      dynamicFontSize16:16,
      dynamicFontSize20:20,
      dynamicFontSize24:24,
      dynamicFontSize26:26,
      dynamicFontSize30:30,
      payImg:'',
      payImgStatus:1,
      payImge:'https://images.yoooooo.com/crm/reseller/ewme.png',
      payNo:0,
      pollingInterval:null,
      payType:1,
      zhifubaoSrc:'',
      zongjiaPayImg:'https://images.yoooooo.com/crm/yzzm.jpg',
      zongjiashow:false,
      zongjiaPayNo:0,
      zongjiaPayImgStatus:1,
      zongjiapayImge:'https://images.yoooooo.com/crm/reseller/ewme.png',
      pollingInterval1:null,
      zongjiaPrice:0,
      vi_length:0
    };
  },
  mounted() {
    this.checkToken()
    window.addEventListener('resize', this.handleResize);
    // const eventSource = new EventSource('https://tossp.yoooooo.com/index.php/index/data/sendPayM');

    //     // 监听事件
    //     eventSource.onmessage = (event) => {
    //       // 解析接收到的消息
    //       const message = JSON.parse(event.data);

    //       this.messages.push(message);
    //     };


  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize); //font
  },
  computed: {
    dynamicFontSize() { //font
      const screenWidth = window.innerWidth;
      return this.baseFontSize30 * (screenWidth / 1920);
      return this.baseFontSize26 * (screenWidth / 1920);
      return this.baseFontSize24 * (screenWidth / 1920);
      return this.baseFontSize20 * (screenWidth / 1920);
      return this.baseFontSize16 * (screenWidth / 1920);

    }
  },
  created() {

    this.loadList()
    this.getScreen()


  },

  methods: {
    handleScroll(event){
      const scrollContainer = event.target;
            // 滚动条的高度
      const scrollHeight = scrollContainer.scrollHeight;
            // 可视区域的高度
      const clientHeight = scrollContainer.clientHeight;
            // 滚动条顶部到顶部的距离
      const scrollTop = scrollContainer.scrollTop;
       
            // 检查是否已经到达底部
      const isBottom = scrollHeight - (scrollTop + clientHeight) < 1; // 这里的1是一个阈值，可以根据需要调整
       
      if (isBottom) {
         if(this.list.length > this.vi_length){
           this.vi_length = this.vi_length+Math.ceil(this.screenHeight / this.vwidth)*6
         }
         console.log(this.vi_length)     
         console.log('滚动条到达底部');
      }
      // const { scrollTop, clientHeight, scrollHeight } = event.target;
       
      // if (scrollTop + clientHeight >= scrollHeight) {
      //   if(this.list.length > this.vi_length){
      //     this.vi_length = this.vi_length+Math.ceil(this.screenHeight / this.vwidth)*6
      //   }
      //   console.log(this.vi_length)
         
      // }
      console.log(this.vi_length)
    },
    getOnece1(){
      if(this.zongjiaPrice>0){
        const form = {'info':this.id,'month':'终身卡','price':this.zongjiaPrice,'token':this.token}
        this.getErweima1(form)
      }

    },
    getErweima1(form){
      this.stopPolling1()
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	data:form,
      	url:'https://tossp.yoooooo.com/index.php/index/pays/hetongWxPay'
      })
      .then(res=>{
        // console.log(res.data)
        if(res.data.code == 200){
          this.zongjiaPayImg = res.data.data
          this.zongjiaPayNo = res.data.no
          this.zongjiaPayImgStatus = 1
          this.startPolling1()
          // this.startCountdown();
        }
        if(res.data.code == 202){
          this.msg(res.data.msg,'error');
        }

      })
      .catch(err=>{

      });
    },
    startPolling1() {
      var status = 1;
      this.pollingInterval1 = setInterval(() => {
        status = status+1;
        if(status > 20){
          this.zongjiaPayImgStatus = 0
          this.zongjiaPayImg = ''
          this.stopPolling1()
        }
        // this.getPayStatus();
      }, 1000);
    },
    stopPolling1() {
      if (this.pollingInterval1) {
        clearInterval(this.pollingInterval1);
        this.pollingInterval1 = null;
      }
    },
    handleResize() {
      this.dynamicFontSize30 = this.baseFontSize30 * (window.innerWidth / 1920);
      this.dynamicFontSize26 = this.baseFontSize26 * (window.innerWidth / 1920);
      this.dynamicFontSize24 = this.baseFontSize24 * (window.innerWidth / 1920);
      this.dynamicFontSize20 = this.baseFontSize20 * (window.innerWidth / 1920);
      this.dynamicFontSize16 = this.baseFontSize16 * (window.innerWidth / 1920);
    },
    payTypeChange(t){
      this.payType = t
      const form = {'info':this.id,'month':this.month,'price':this.price,'token':this.token}
      if(this.payType == 1){
        this.startPolling()
        this.getErweima(form)
      }else{

        this.getZhifubao(form)
      }
    },
    checkToken() {
      const form = {'info': this.id, 'token': this.token}
      const axiosInstance = this.$axios.create({
        headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
        method: 'post',
        data: form,
        url: 'https://tossp.yoooooo.com/index.php/index/data/checkToken'
      })
        .then(res => {
          if (res.data.code != 200) {
            // console.log('111')
            this.$router.push({path: '/Login?info=' + this.id})
          }
          // this.msg(res.data.data,'error');
        })
        .catch(err => {

        });
    },
    getOnece(){
      const form = {'info':this.id,'month':this.month,'price':this.price,'token':this.token}
      if(this.payType == 1){
        this.getErweima(form)
      }else{

        this.getZhifubao(form)
        // this.getZhifubao(form)
      }
      // this.getErweima(form)
    },
    changePrice(t) {
      this.month = t;
      const priceMap = {
        1: this.price1,
        3: this.price3,
        6: this.price6,
        12: this.price12
      };
      this.price = priceMap[t] || this.price;

      const form = {'info':this.id,'month':t,'price':this.price,'token':this.token}
      if(this.payType == 1){
        this.getErweima(form)
      }else{

        this.getZhifubao(form)

      }

    },
    getZhifubao(form){
      this.stopPolling()
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	data:form,
      	url:'https://tossp.yoooooo.com/index.php/index/pays/getZhifubao'
      })
      .then(res=>{
        // console.log(res.data)
        if(res.data.code == 200){
          this.zhifubaoSrc = res.data.data
          // console.log(this.zhifubaoSrc)
          this.payNo = res.data.no
          this.payImgStatus = 1
          this.startPolling()
          // this.startCountdown();
        }
        if(res.data.code == 202){
          this.msg(res.data.msg,'error');
        }

      })
      .catch(err=>{

      });
    },
    getErweima(form){
      this.stopPolling()
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	data:form,
      	url:'https://tossp.yoooooo.com/index.php/index/pays/nativePay'
      })
      .then(res=>{
        // console.log(res.data)
        if(res.data.code == 200){
          this.payImg = res.data.data
          this.payNo = res.data.no
          this.payImgStatus = 1
          this.startPolling()
          // this.startCountdown();
        }
        if(res.data.code == 202){
          this.msg(res.data.msg,'error');
        }

      })
      .catch(err=>{

      });
    },
    startPolling() {
      var status = 1;
      this.pollingInterval = setInterval(() => {
        status = status+1;
        if(status > 20){
          this.payImgStatus = 0
          this.zhifubaoSrc = ''
          this.stopPolling()
        }
        this.getPayStatus();
      }, 1000);
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    getPayStatus(){
      const form = {'id':this.payNo}
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	data:form,
      	url:'https://tossp.yoooooo.com/index.php/index/pays/getPayStatus'
      })
      .then(res=>{
        // console.log(res.data)
        if(res.data.code == 200){
          this.zhifuShow = 1
          this.stopPolling();
          this.msg('会员充值成功', 'success');
        }

      })
      .catch(err=>{

      });
    },
    uploadPaishe() {
      this.uploadPhoto(this.formData)
    },
    uploadsx() {
      this.paishe = 1
      // 开启摄像头
      navigator.mediaDevices.getUserMedia({video: true})
        .then(stream => {
          this.stream = stream;
          const video = this.createVideoElement(stream);

          video.addEventListener('loadedmetadata', () => {
            // 设置video的宽高
            video.width = video.videoWidth;
            video.height = video.videoHeight;

            // 捕捉图片
            this.captureImage(video);
          });
        }).catch(error => {
        this.msg('摄像头访问失败', 'error');
        this.sc_left = 0
        console.error('摄像头访问错误:', error)
      });

    },
    createVideoElement(stream) {
      const video = document.createElement('video');
      video.srcObject = stream;
      video.play(); // 播放视频流
      document.body.appendChild(video); // 可以用于预览
      return video;
    },
    captureImage(video) {
      const canvas = this.$refs.canvas;
      canvas.width = video.width;
      canvas.height = video.height;
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      this.photo = canvas.toDataURL('image/png');

      // 上传图片
      const imageBlob = this.dataURLtoBlob(this.photo);
      this.formData = new FormData();
      this.formData.append('file', imageBlob, 'photo.png');
      // this.uploadPhoto(formData);
    },
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new Blob([u8arr], {type: mime});
    },
    beforeDestroy() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
      }
    },
    uploadPhoto(formData) {
      this.beforeDestroy()
      const axiosInstance = this.$axios.create({
        headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
        method: 'POST',
        data: this.formData,
        url: 'https://data3.yoooooo.com/index.php/index/data/pythonImgSave'
      })
        .then(res => {
          var url = 'https://data3.yoooooo.com/tui_liebiao/' + res.data.data
          this.otherLeftImgAdd(this.id, url)
          this.paishe = 0
          this.photo = null
        })
        .catch(err => {

        });
    },
    handleAvatarSuccess(res, file) {
      var url = 'https://data3.yoooooo.com/tui_liebiao/' + res.data
      // console.log(url)
      this.otherLeftImgAdd(this.id, url)

    },
    otherLeftImgAdd(id, url) {

      const axiosInstance = this.$axios.create({
        headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
        method: 'get',
        params: {


          img: url,
          i_id: id,


        },
        url: 'https://tossp.yoooooo.com/index.php/index/data/videoResellerAddImg'
      })
        .then(res => {

          this.msg('添加成功', 'success');
          var data = res.data.data
          var ks = Math.floor(Math.random() * (this.shopkb.length - 1));
          data['bkg'] = this.shopkb[ks]['img'];

          this.list.push(data)
          this.videos.push(data['id'])
          this.videoData.push(data)
          // this.$set(this.list,this.list.length,data);
          this.listSee.push(data)
          console.log(this.list)
          var hei = Math.ceil(this.list.length / 6) * (this.vwidth + 2)
          if (hei > this.screenHeight) {
            this.leftheight = this.screenHeight
          } else {
            this.leftheight = Math.ceil(this.list.length / 6) * (this.vwidth + 2)
          }
          this.sc_left = 0

        })
        .catch(err => {

        });


    },

    uploadb() {
      this.$refs.uploadImg.click();
      // this.$nextTick(() => {
      //   this.$refs.uploadImg.click();
      // });
    },
    scLeft() {
      if (this.sc_left == 0) {
        this.sc_left = 1
        this.other_left_sousuo = 0
        this.other_left = 0
      } else {
        this.sc_left = 0
      }
    },
    otherLeftQd() {
      this.other_left_sousuo = 0
      var datas = this.listSee.slice()
      var name = this.search_left
      var data = []

      datas.forEach(function (item, index) {

        if (item['beizhu'].includes(name)) {
          var cc = [item]
          data = data.concat(cc);
        }

      })
      // clearInterval(this.interval2);
      this.list = data
      // this.startVideo()
      console.log(data, 'data')
      console.log(this.list, 'list')
      var hei = Math.ceil(this.list.length / 6) * (this.vwidth + 2)
      if (hei > this.screenHeight) {
        this.leftheight = this.screenHeight
      } else {
        this.leftheight = Math.ceil(this.list.length / 6) * (this.vwidth + 2)
      }
    },
    otherLeftQx() {
      this.other_left_sousuo = 0
    },
    otherLeft() {
      if (this.other_left == 0) {
        this.other_left = 1
        this.other_left_sousuo = 0
        this.sc_left = 0
      } else {
        this.other_left = 0
      }


    },
    otherLeftAdd() {

      const axiosInstance = this.$axios.create({
        headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
        method: 'get',
        params: {


          beizhu: this.beizhu,
          i_id: this.id,


        },
        url: 'https://tossp.yoooooo.com/index.php/index/data/videoResellerAddText'
      })
        .then(res => {

          this.msg('添加成功', 'success');
          var data = res.data.data
          var ks = Math.floor(Math.random() * (this.shopkb.length - 1));
          data['bkg'] = this.shopkb[ks]['img'];

          this.list.push(data)
          this.videos.push(data['id'])
          this.videoData.push(data)
          // this.$set(this.list,this.list.length,data);
          this.listSee.push(data)
          console.log(this.list)
          var hei = Math.ceil(this.list.length / 6) * (this.vwidth + 2)
          if (hei > this.screenHeight) {
            this.leftheight = this.screenHeight
          } else {
            this.leftheight = Math.ceil(this.list.length / 6) * (this.vwidth + 2)
          }
          this.other_left = 0

        })
        .catch(err => {

        });


    },
    otherRightAdd() {

      const axiosInstance = this.$axios.create({
        headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
        method: 'get',
        params: {


          beizhu: this.beizhu_right,
          i_id: this.id,


        },
        url: 'https://tossp.yoooooo.com/index.php/index/data/videoResellerTextAddText'
      })
        .then(res => {

          this.msg('添加成功', 'success');
          var data = res.data.data
          var ks = Math.floor(Math.random() * (this.shopkb.length - 1));
          data['bkg'] = this.shopkb[ks]['img'];

          this.texts.push(data)
          this.textChose.push(data['id'])
          this.textData.push(data)

          this.textsSee.push(data)

          this.other_right = 0

        })
        .catch(err => {

        });


    },
    leftShow(t) {
      this.left_show = t
      if (t == 2) {
        this.other_right = 0
        this.right_show = 1
        this.other_right_sousuo = 0
      }
      if (t == 1) {
        this.other_left = 0
        this.other_left_sousuo = 0
        this.sc_left = 0
      }
    },
    searchLeft() {
      if (this.other_left_sousuo == 0) {
        this.other_left_sousuo = 1
        this.other_left = 0
        this.sc_left = 0
      } else {
        this.other_left_sousuo = 0
      }
    },
    otherRight() {
      if (this.other_right == 0) {
        this.other_right = 1
        this.other_right_sousuo = 0
      } else {
        this.other_right = 0
      }
    },
    rightShow(t) {
      this.right_show = t
      if (t == 2) {
        this.other_left = 0
        this.left_show = 1
        this.other_left_sousuo = 0
        this.sc_left = 0
      }
      if (t == 1) {
        this.other_right = 0
        this.other_right_sousuo = 0
      }
    },
    searchRight() {
      if (this.other_right_sousuo == 0) {
        this.other_right_sousuo = 1
        this.other_right = 0
      } else {
        this.other_right_sousuo = 0
      }
    },
    otherRightQd() {
      this.other_right_sousuo = 0
      var datas = this.textsSee.slice()
      var name = this.search_right
      var data = []
      datas.forEach(function (item, index) {
        if (item['name'].includes(name)) {
          var cc = [item]
          data = data.concat(cc);
        }

      })
      // clearInterval(this.interval2);
      this.texts = data

    },
    otherRightQx() {
      this.other_right_sousuo = 0
    },
    zuhe() {


      const axiosInstance = this.$axios.create({
        headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
        method: 'get',
        params: {

          tt: this.textChose.join(','),
          vv: this.videos.join(','),
          i_id: this.id,


        },
        url: 'https://tossp.yoooooo.com/index.php/index/data/shopGuanli_zuhe_add_test'
      })
        .then(res => {
          // this.urls = res.data.data
          this.msg('组合成功', 'success');
          // window.open('https://universe.top/'+urls);
          // console.log('https://universe.top/'+res.data.data)
          window.location.href = 'https://universe.top/' + res.data.data
          // window.open(url, '_blank');
        })
        .catch(err => {

        });
    },
    letBack() {
      this.yulan = 1
      //   this.list = []
      //   this.texts = []

      //   var that = this
      //   this.listSee.forEach(function(item, index) {
      //     that.list.push(item)
      //   })
      //   this.textsSee.forEach(function(item, index) {
      //     that.texts.push(item)
      //   })
      var hei = Math.ceil(this.list.length / 6) * (this.vwidth + 2)
      if (hei > this.screenHeight) {
        this.leftheight = this.screenHeight
      } else {
        this.leftheight = Math.ceil(this.list.length / 6) * (this.vwidth + 2)
      }
    },
    letSee() {
      if (this.textChose.length == 0) {
        this.msg('还没选择右侧能力', 'error')
        return false
      }
      if (this.videos.length == 0) {
        this.msg('还没选择左侧展示视频', 'error')
        return false
      }


      // this.list = []
      // this.texts = []

      // var that = this
      // this.videoData.forEach(function(item, index) {
      //   that.list.push(item)
      // })
      // this.textData.forEach(function(item, index) {
      //   that.texts.push(item)
      // })

      this.yulan = 2
      var hei = Math.ceil(this.videoData.length / 6) * (this.vwidth + 2)
      if (hei > this.screenHeight) {
        this.leftheight = this.screenHeight
      } else {
        this.leftheight = Math.ceil(this.videoData.length / 6) * (this.vwidth + 2)
      }
    },
    videoChangeCheck(id, img) {

      var bb = this.videos.indexOf(id)
      if (bb !== -1) {

        // return {'background-image': `url(${img})`}
        return {'background-image': `url(${img})`,'width':this.vwidth+'px','height':this.vwidth+'px'}
      } else {

        return {'width':this.vwidth+'px','height':this.vwidth+'px'}
      }
    },
    videoChange(id, url) {
      if (this.yulan == 2) {
        this.open(url)
      } else {
        var t = 1
        this.videos.forEach(function (item, index) {
          if (item == id) {
            t = 2
          }
        })
        if (t == 1) {
          this.videos.push(id)
          if (this.video_url != url) {
            this.open(url)
          }
        } else {
          var tt = []
          this.videos.forEach(function (item, index) {
            if (item != id) {
              tt.push(item)
            }

          })
          this.videos = tt


        }
        var that = this
        var video_ids = []
        this.videoData = []
        this.listSee.forEach(function (item, index) {
          const bb = that.videos.indexOf(item['id'])
          if (bb !== -1) {
            that.videoData.push(item)
            video_ids.push(item['id'])
          }
        })
        this.videos = video_ids


        console.log(this.videos, 'video')
      }

    },
    textChangeCheck(id, color) {


      var bb = this.textChose.indexOf(id)
      if (bb !== -1) {

        return {'background-color': '#' + color, 'color': '#000'}

      } else {

        return {}
      }
    },
    textChange(id, url,t) {
      if(t > 99){
        return false
      }
      if (this.yulan == 2) {
        this.open(url)
      } else {
        var t = 1
        this.textChose.forEach(function (item, index) {
          if (item == id) {
            t = 2
          }
        })
        if (t == 1) {
          this.textChose.push(id)
          if (this.video_url != url) {
            this.open(url)
          }
        } else {
          var tt = []
          this.textChose.forEach(function (item, index) {
            if (item != id) {
              tt.push(item)
            }

          })
          this.textChose = tt
        }
        var that = this
        var text_ids = []
        this.textData = []
        this.textsSee.forEach(function (item, index) {
          const bb = that.textChose.indexOf(item['id'])
          if (bb !== -1) {
            that.textData.push(item)
            text_ids.push(item['id'])
          }
        })
        this.textChose = text_ids
        console.log(this.textChose, 'text')
      }

    },
    down() {
      var downloadUrl = this.downUrl1;
      var a = document.createElement('a');
      a.href = downloadUrl;
      a.download = 'file.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    getScreen() {
      if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {

        window.location.href = 'https://m.universe.top/Reseller?id=' + this.id

      }

    },
    commitdl() {
      const axiosInstance = this.$axios.create({
        headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if (this.qiye == '') {
        this.msg('请填写您的名称', 'error')
        return false
      }
      if (this.email == '') {
        this.msg('请填写您的手机号', 'error')
        return false
      }
      axiosInstance({
        method: 'get',
        params: {
          name: this.qiye,
          email: this.email,
          other: this.other

        },
        url: 'https://tossp.yoooooo.com/index.php/index/data/videoDl'
      })
        .then(res => {
          this.qiye = '';
          this.email = '';
          this.other = '';
          this.msg('提交成功', 'success');
          this.dl(2)
        })
        .catch(err => {

        });
    },
    commitdg() {
      const axiosInstance = this.$axios.create({
        headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if (this.qiye1 == '') {
        this.msg('请填写您的名称', 'error')
        return false
      }
      if (this.email1 == '') {
        this.msg('请填写您的手机号', 'error')
        return false
      }
      axiosInstance({
        method: 'get',
        params: {
          name: this.qiye1,
          email: this.email1,
          other: this.other1

        },
        url: 'https://tossp.yoooooo.com/index.php/index/data/videoDg'
      })
        .then(res => {
          this.qiye1 = '';
          this.email1 = '';
          this.other1 = '';
          this.msg('提交成功', 'success');
          this.dg(2)
        })
        .catch(err => {

        });
    },
    dg(t) {
      this.dinggou2 = t
      this.open(this.dgurl)
    },
    dl(t) {
      this.daili2 = t
      this.open(this.dlurl)
    },
    restartVideo() {
      this.$refs.videoPlayer.currentTime = 0;
      this.$refs.videoPlayer.play();
    },
    open(url) {
      if (url == '无') {
        return false
      }
      this.ishow = false
      this.video_url = ""
      setTimeout(() => {
        this.ishow = true
        this.video_url = url

        this.$nextTick(() => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.play();
          }
        });
      }, 200);

    },

    startVideo() {
      var that = this

      this.interval2 = setInterval(() => {

        that.list.forEach(function (item, index) {

          if (item['num'] < item['nums']) {
            item['num'] = item['num'] + 1;
            that.$set(that.list, index, item);
            // that.$set(that.list, index, {'id':item['id'],'img':item['img'],'name':item['name'],'url':item['url'],'num':item['num']+1,'nums':item['nums'],'typea':item['typea'],'typeb':item['typeb'],'typec':item['typec'],'typed':item['typed']});
          } else {
            if (item['typed'] == 0) {
              item['typed'] = 1;
              item['typec'] = 1;

              item['num'] = 0;
              item['nums'] = item['numz'];
              that.$set(that.list, index, item);
              setTimeout(() => {
                item['typec'] = 2;
                item['typea'] = 1;
                that.$set(that.list, index, item);
              }, 400);
              setTimeout(() => {
                item['typea'] = 0;
                that.$set(that.list, index, item);
              }, 800);
            } else {
              item['typed'] = 0;
              item['typeb'] = 1;

              item['num'] = 0;
              item['nums'] = item['numt'];
              that.$set(that.list, index, item);

              setTimeout(() => {
                item['typeb'] = 2;
                item['typea'] = 2;
                that.$set(that.list, index, item);
              }, 400);
              setTimeout(() => {
                item['typea'] = 0;
                that.$set(that.list, index, item);
              }, 800);
            }

          }

        })

      }, 1000);
      this.interval3 = setInterval(() => {

        that.videoData.forEach(function (item, index) {

          if (item['num'] < item['nums']) {
            item['num'] = item['num'] + 1;
            that.$set(that.videoData, index, item);
            // that.$set(that.list, index, {'id':item['id'],'img':item['img'],'name':item['name'],'url':item['url'],'num':item['num']+1,'nums':item['nums'],'typea':item['typea'],'typeb':item['typeb'],'typec':item['typec'],'typed':item['typed']});
          } else {
            if (item['typed'] == 0) {
              item['typed'] = 1;
              item['typec'] = 1;

              item['num'] = 0;
              item['nums'] = item['numz'];
              that.$set(that.videoData, index, item);
              setTimeout(() => {
                item['typec'] = 2;
                item['typea'] = 1;
                that.$set(that.videoData, index, item);
              }, 400);
              setTimeout(() => {
                item['typea'] = 0;
                that.$set(that.videoData, index, item);
              }, 800);
            } else {
              item['typed'] = 0;
              item['typeb'] = 1;

              item['num'] = 0;
              item['nums'] = item['numt'];
              that.$set(that.videoData, index, item);

              setTimeout(() => {
                item['typeb'] = 2;
                item['typea'] = 2;
                that.$set(that.videoData, index, item);
              }, 400);
              setTimeout(() => {
                item['typea'] = 0;
                that.$set(that.videoData, index, item);
              }, 800);
            }

          }

        })

      }, 1000);
    },
    startTu() {
      var that = this
      var dl = 0;
      var dg = 0;

      this.interval2 = setInterval(() => {
        if (dl == 5) {
          dl = 0
          var ks = Math.floor(Math.random() * (that.dailis.length - 1));
          that.daili = that.dailis[ks]['url'];
        } else {
          dl = dl + 1
        }
        if (dg == 7) {
          dg = 0
          var ks = Math.floor(Math.random() * (that.dinggous.length - 1));
          that.dinggou = that.dinggous[ks]['url'];
        } else {
          dg = dg + 1
        }


      }, 1000);

    },
    toPage(name) {
      this.$router.push('/' + name);
    },
    loadList() {
      const axiosInstance = this.$axios.create({
        headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
        method: 'get',
        params: {
          name: '宇宙一次幂(深圳)机器人有限公司',
          id: this.id,
          token: this.token
        },
        url: 'https://tossp.yoooooo.com/index.php/index/data/videoListsReseller'
      })
        .then(res => {
          var videoList = res.data.list;
          var testList = res.data.texts;
          // this.list = res.data.list;
          // this.texts = res.data.texts;
          this.shopkb = res.data.shopkb;
          this.dailis = res.data.shopdl;
          this.dinggous = res.data.shopdg;
          this.daili = this.dailis[0]['url'];
          this.dinggou = this.dinggous[0]['url'];
          this.dlurl = res.data.url['dlurl'];
          this.dgurl = res.data.url['dgurl'];
          this.downUrl1 = res.data.zuhe['url1'];
          this.downUrl2 = res.data.zuhe['url2'];
          this.downUrl3 = res.data.zuhe['url3'];
          this.price = res.data.zuhe['price1'];
          this.price1 = res.data.zuhe['price1'];
          this.price3 = res.data.zuhe['price2'];
          this.price6 = res.data.zuhe['price3'];
          this.price12 = res.data.zuhe['price4'];
          this.company = res.data.zuhe['company'];
          this.logo = res.data.zuhe['logo'];
          this.zongjiaPrice = res.data.zuhe['jiage'];
          this.zhifuShow = res.data.vip;
          if(this.zhifuShow == 0){
            this.getOnece()
          }
          if(this.zongjiaPrice > 0){
            this.getOnece1()
          }

          var that = this
          videoList.forEach(function (item, index) {
            item['typed'] = 1;
            item['typec'] = 2;
            item['typeb'] = 2;
            item['typea'] = 0;
            var ks = Math.floor(Math.random() * (that.shopkb.length - 1));
            item['bkg'] = that.shopkb[ks]['img'];
          })
          testList.forEach(function (item, index) {
            if(item['t'] > 99){
              that.textChose.push(item['id'])
              that.textData.push(item)
            }
          })
          this.list = videoList.slice();
          this.texts = testList.slice();
          this.listSee = videoList.slice();
          this.textsSee = testList.slice();
          this.startVideo()
          this.startTu()
          this.video_url = this.list[0]['url']
          this.daili2 = 2
          this.dinggou2 = 2
          this.open(this.list[0]['url'])
          this.vi_length = Math.ceil(this.screenHeight / this.vwidth)*6
          var hei = Math.ceil(this.list.length / 6) * (this.vwidth + 2)
          if (hei > this.screenHeight) {
            this.leftheight = this.screenHeight
          } else {
            this.leftheight = Math.ceil(this.list.length / 6) * (this.vwidth + 2)
          }

        })
        .catch(err => {

        });
    },
    msg(msg, type) {
      this.$message({
        message: msg,
        type: type
      });
    },


  }


}
</script>

<style lang="scss">
/* 外部正方形格子，带渐变边框和投影 */
.grid_b {
    position: absolute;
    z-index: 1010;
    bottom: 2px;
    right: 0px;
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 2列布局 */
    grid-template-rows: repeat(2, 1fr);    /* 2行布局 */
    width: 10vw;
    height: 10vw;
    // border: 1px solid transparent;
    // border-radius: 15px;
    // border-image: linear-gradient(1deg, #ab86ff, #c29dff, #a17aff) 1;
    background-origin: border-box;
    background-clip: content-box, border-box;
    box-shadow: 0 4px 10px rgba(143, 75, 255, 0.5); /* 投影效果 */
    background-color: #0d0d0d;
}

/* 每个小格子样式 */
.cell_b {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border: 1px solid transparent; /* 边框透明，以便显示渐变 */
    border-radius: 10px; /* 可选：为每个小格子添加圆角 */
    border-image: linear-gradient(45deg, #ab86ff, #c29dff, #a17aff) 1;
    background-origin: border-box;
    background-clip: content-box, border-box;
    background-color: black; /* 每个小格子的底色 */

}

/* 图标样式 */
.icon_b {
    width: 40px;
    height: 40px;
    margin-bottom: 10px;
}

/* 文字样式 */
.text_b {
    text-align: center;
    font-size: 16px;
    color: #fff;
    margin: 0;
}
.pay-type{
    padding:0px 10px;
    .zfb{
      display: flex;
      justify-content:center;
      // margin: 10px 0px;
      .zfb-span{
        color: #fff;
        font-size: 20px;
        padding-left: 40px;
        margin: 10px 0px;
        position: relative;
        &::before {
          content: '';
          background-image: url("../../assets/image/zfb.png");
          width: 33px;
          height: 33px;
          position: absolute;
          left: 0px;
          top: 0px;

        }
      }
    }
    .wx{
      display: flex;
      justify-content:center;
      margin-bottom: 10px;
      .wx-span{
        color: #fff;
        font-size: 20px;
        padding-left: 40px;
        position: relative;
        margin: 10px 0px;
        &::before {
          content: '';
          background-image: url("../../assets/image/wx.png");
          width: 33px;
          height: 28px;
          position: absolute;
          left: 0px;
          top: 0px;

        }
      }

    }
  }

.reseller {
  font-family:'hanyi75';
  box-shadow: 0px 2px 6px 2px rgba(73, 73, 73, 0.23);
  border: 1px solid #6d53f4;
  border-radius: 5px;
  position: absolute;
  top: 45vh;
  left: 50%;
  transform: translate(-50%, -50%); /* 用于修正居中元素的本身尺寸一半 */
  width: 40vw; /* 示例宽度 */
  z-index: 99999999;
  background: rgba(9,9,9,1);

  &-header {
    border-radius: 5px 5px 0px 0px;
    position: relative;
    width: 100%;
    height: 6vh;
    line-height: 6vh;
    background: #6d53f4;
    color: #fff;
    text-align: center;
    font-size: 24px;
  }
  &-content{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2vh;
    padding:0px 5%;
    font-size: 20px;
    p{
      margin:1vh;
    }
    &-box{
      border:2px solid rgba(226,226,226,1);
      background:rgba(255,255,255,1);
      width: 22%;
      text-align: center;
      border-radius: 8px;
      color: #000;
    }
  }
  &-text{
    color: #fff;
    text-align: center;
    line-height: 8vh;
    letter-spacing: 2px;
    font-size: 18px;
  }
  &-wx{
    margin:0.7vh auto 1vh;
    width: 15vh;
    height: 15vh;
    border:1px solid #f8f8f8;
    box-shadow: 0px 2px 6px 2px rgba(73, 73, 73, 0.23);
  }
  &-font{
    text-align: center;
    font-size: 16px;
    line-height: 1vh;
    margin-top: 3vh;
    letter-spacing: 1px;
    margin-bottom: 5vh;
    color:#a3a3a3;
  }
}
.fontColor1{
  font-weight: bold;
  font-size: 30px;
}
.fontColor2{
  color:#fae83e;
  font-size: 30px;
}
.fontColor3{
  color:#fae83e;
  font-size: 18px;
}
.active{
  border:2px solid rgba(182,221,252,1);
  background:rgba(187,213,255,1);
  color:#0030ff;
}
.fontColor4{
  color: #fae83e;
  font-size: 16px;
}

.zhifu {
  position: absolute;
  background-image: url('https://images.yoooooo.com/crm/reseller/zhifu1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  width: 42vw;
  height: 64vh;
  top: 18vh;
  left: 29vw;
}

.zhifu_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7); /* 半透明背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1019;
}
.zhifu_overlayz {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7); /* 半透明背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1019;
}
.zhifu_ewm {
  position: absolute;
  top: 34vh;
  left: 40%;
  width: 20%;
}

.zhifu_jiage {
  position: absolute;
  top: 45%;
  text-align: center;
  width: 100%;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 4px;
}

.zhifu_mc {
  background-image: url('https://images.yoooooo.com/crm/reseller/zhifu3.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  width: 8vw;
  height: 10vh;
  margin-left: 1vw;
  color: #007ffe;
}

.zhifu_m {
  background-image: url('https://images.yoooooo.com/crm/reseller/zhifu2.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  width: 8vw;
  height: 10vh;
  margin-left: 1vw;
}

.zhifu_mt {
  margin-top: 2.5vh;
  text-align: center;
  font-size: 18px;
}

.zhifu_jg {
  text-align: center;
  font-size: 24px;
}

.yl_fh {
  color: #fff;
  width: 80px;
  background-image: url('https://images.yoooooo.com/crm/reseller/anniubj.png');
  text-align: center;
  background-size: cover; /* 背景图片覆盖整个元素 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center;
}

.s_q_sc_left {
  color: #fff;
  width: 80px;
  height: 30px;
  line-height: 30px;

  margin-left: 15px;
  background-image: url('https://images.yoooooo.com/crm/reseller/anniubj.png');
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.s_q_sc_right {
  color: #fff;
  width: 80px;
  height: 30px;
  line-height: 30px;

  margin-right: 15px;
  background-image: url('https://images.yoooooo.com/crm/reseller/anniubj.png');
  text-align: center;
  background-size: cover; /* 背景图片覆盖整个元素 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center;
}

.other_left {
  position: absolute;
  /* color: #fff; */
  width: 238px;
  height: 340px;
  top: 40px;
  left: 136px;
  background-image: url('https://images.yoooooo.com/crm/reseller/otherbj1.png');
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
  /* background-position: center; */
}

.other_left::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

#other_left_textarea {
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 90%;
  height: 100%;
  resize: none;
  background: transparent;
  border: none;
  outline: none;
  padding: 15px;
}

.other_right {
  position: absolute;
  /* color: #fff; */
  width: 238px;
  height: 340px;
  top: 40px;
  right: 45px;
  background-image: url('https://images.yoooooo.com/crm/reseller/otherbj1.png');
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
  /* background-position: center; */
}

.other_right::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

#other_right_textarea {
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 90%;
  height: 100%;
  resize: none;
  background: transparent;
  border: none;
  outline: none;
  padding: 15px;
}


.other_left_sousuo {
  position: absolute;
  /* color: #fff; */
  width: 400px;
  height: 40px;
  top: 40px;
  left: 45px;
  background-image: url('https://images.yoooooo.com/crm/reseller/sousuo.png');
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
  /* background-position: center; */
}

.other_left_sousuo::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

#other_left_input {
  color: #000;
  position: absolute;
  top: -5px;
  left: 0;
  width: 72%;
  margin-left: 70px;
  height: 100%;
  resize: none;
  background: transparent;
  border: none;
  outline: none;
  padding: 5px;
}

.other_right_sousuo {
  position: absolute;
  /* color: #fff; */
  width: 400px;
  height: 40px;
  top: 40px;
  right: 140px;
  background-image: url('https://images.yoooooo.com/crm/reseller/sousuo.png');
  text-align: center;
  background-size: cover;
  background-repeat: no-repeat;
  /* background-position: center; */
}

.other_right_sousuo::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

#other_right_input {
  color: #000;
  position: absolute;
  top: -5px;
  left: 0;
  width: 72%;
  margin-left: 70px;
  height: 100%;
  resize: none;
  background: transparent;
  border: none;
  outline: none;
  padding: 5px;
}


ul li {
  font-family: 'hanyi75', sans-serif;
  font-weight: 400;
}

@keyframes float {
  0% {
    transform: translate(20px, 20px);
  }
  20% {
    transform: translate(900px, 80px);
  }
  40% {
    transform: translate(750px, 500px);
  }
  60% {
    transform: translate(900px, 900px);
  }
  80% {
    transform: translate(50px, 950px);
  }
  100% {
    transform: translate(20px, 20px);
  }
}

.float-animation {
  /* display: inline-block; */
  animation: float 30s infinite;
}

@keyframes float1 {
  0% {
    transform: translate(950px, 900px);
  }
  20% {
    transform: translate(20px, 850px);
  }
  40% {
    transform: translate(300px, 500px);
  }
  60% {
    transform: translate(20px, 20px);
  }
  80% {
    transform: translate(950px, 50px);
  }
  100% {
    transform: translate(950px, 900px);
  }
}

.float-animation1 {
  /* display: inline-block; */
  animation: float1 30s infinite;
}

.donghuap {
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
  overflow-x: hidden;
  position: relative;
  text-align: center;
  border: 1px solid #BBBBBB;
}

.donghuai {
  display: flex;
  transform: translateX(200%);
  transition: transform 0.4s ease;
  justify-content: center;
}

.adonghua {
  visibility: hidden;
}

.ddonghua {
  transform: translateX(0);
}

.edonghua {
  display: flex;
  transform: translateX(-200%);
  transition: transform 0.6s ease;
  justify-content: center;
}

.el-dropdown-menu__item {
  color: #ffffff;
  font-weight: bold;
  font-family: guanwangdaohang;
}

.popper__arrow {
  display: none;
}

.content {
  background: #939AA0;
  width: 100%;
  height: 100%;
}

body {
  overflow-x: hidden;
  overflow-y: hidden;
}

.el-scrollbar__wrap {
  background-color: black;
}

.bordered-box {
  overflow-wrap: break-word;
  /* margin-left: 20px; */
}

.beian1 {
  position: fixed; /* 定位为固定位置，覆盖整个视窗 */
  color: #616161;
  /* top: 0; */
  left: 42%;
  /* right: 0; */
  bottom: 0;

  z-index: 1000; /* 确保蒙层在其他内容之上 */
}


</style>



// WEBPACK FOOTER //
// src/components/main/reseller.vue